export default "__VITE_ASSET__C6_Ifykf__"